import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { useAppSelector } from "hooks/storeHooks"
import { UploadBulkProducts } from "pages/Products/UploadBulkProducts/UploadBulkProducts"
import React, { useState } from "react"
import { IntegrationType } from "types"
import { AddProductStepOne } from "./AddProductStepOne"
import { SelectProductsEcommerceStepTwo } from "pages/Products/AddProductsModal/SelectProductsEcommersStepTwo/SelectProductsEcommerceStepTwo"
import { useTranslation } from "react-i18next"
import { Typography } from "@strapi/design-system"
import { ProductCategories } from "components/Navbar/types"

interface StepContentProps {
  step: number
  userType: IntegrationType
  selectedModalType: string
  category: ProductCategories
  onAlert: (data: { error: boolean; text: string }) => void
  onClose: () => void
  handleGoToStepTwo: (type?: string) => void
  handleGoToStepFirst: (type?: string) => void
}

const StepContent: React.FC<StepContentProps> = ({
  step,
  userType,
  selectedModalType,
  category,
  onAlert,
  onClose,
  handleGoToStepTwo,
  handleGoToStepFirst,
}) => {
  if (step === 1) return <AddProductStepOne handleGoToStepTwo={handleGoToStepTwo} />
  if (step === 2 && userType !== IntegrationType.COMMON)
    return selectedModalType === "from-store" ? (
      <SelectProductsEcommerceStepTwo category={category} />
    ) : (
      <UploadBulkProducts
        onAlert={onAlert}
        backHandler={() => handleGoToStepFirst()}
        onClose={onClose}
      />
    )

  return (
    <UploadBulkProducts
      onAlert={onAlert}
      backHandler={() => handleGoToStepFirst()}
      onClose={onClose}
    />
  )
}

interface AddProductsModalProps {
  onAlert: (data: { error: boolean; text: string }) => void
  onClose: () => void
  isOpen: boolean
  category: ProductCategories
}

export const AddProductsModal: React.FC<AddProductsModalProps> = ({
  onAlert,
  onClose,
  isOpen,
  category,
}) => {
  const userType = useAppSelector((state) => state.user.userInfo.integrationType)
  const [step, setStep] = useState(userType !== IntegrationType.COMMON ? 2 : 1)
  const { t } = useTranslation()
  const [selectedModalType, setSelectedModalType] = useState(
    userType !== IntegrationType.COMMON ? "from-store" : "bulk"
  )

  const handleGoToStepTwo = (type?: string) => {
    if (type) setSelectedModalType(type)
    setStep(2)
  }
  const handleGoToStepFirst = (type?: string) => {
    if (type) setSelectedModalType(type)
    setStep(1)
  }
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className={"!max-w-xl  gap-0"}>
        <DialogTitle></DialogTitle>

        <DialogHeader>
          <Typography
            fontWeight="bold"
            style={{
              fontSize: "16px",
            }}
          >
            {t("addProductsModal.selectProduct")}
          </Typography>
        </DialogHeader>
        <StepContent
          step={step}
          userType={userType}
          selectedModalType={selectedModalType}
          category={category}
          onAlert={onAlert}
          onClose={onClose}
          handleGoToStepTwo={handleGoToStepTwo}
          handleGoToStepFirst={handleGoToStepFirst}
        />
      </DialogContent>
    </Dialog>
  )
}
